import PropTypes from 'prop-types';

export const renderablePropType = PropTypes.oneOfType([
	PropTypes.node,
	PropTypes.string,
	PropTypes.func,
]);
